<template>
  <BaseDialog max-width="800" persistent :value="true">
    <template #modal>
      <BaseCosmoCard>
        <template #title>
          <div class="modal_header">
            <BaseTitle v-text="$t('utils.xml_template')" />
            <BaseButtonIcon
              class="close_icon"
              icon="$mdiClose"
              @click="reset()"
            />
          </div>
        </template>
        <div class="modal_content">
          <textarea
            ref="xmlTextarea"
            class="xml_pattern"
            rows="1"
            :value="xmlPattern"
            disabled
            @input="autoResize"
          />
        </div>
      </BaseCosmoCard>
    </template>
  </BaseDialog>
</template>

<script>
export default {
  name: "XMLPatternPreviewer",
  props: {
    xmlPattern: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.autoResize();
  },

  methods: {
    autoResize() {
      this.$nextTick(() => {
        const textarea = this.$refs.xmlTextarea;
        textarea.style.height = "auto"; // reset
        textarea.style.height = textarea.scrollHeight + "px"; // adjust
      });
    },
    reset() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal_header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding-top: 8px;
  flex-wrap: wrap;
  .modal_title {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: #353542;
  }
  .close_icon {
    margin-left: auto;
  }
}
.modal_content {
  padding-top: 24px;
  position: relative;
  .xml_pattern {
    padding: 0 16px;
    max-height: 70vh;
    width: 100%;
    font-size: 16px;
    line-height: 24px;
    color: #353542;
  }
}
</style>
